module.exports = __webpack_public_path__ + "img/emoji-sick-80x80.18f509a6.png";